module.exports = __webpack_public_path__ + "img/imgEnlarge.47725930.svg";